import axios from "axios";
import production from '../access/environment';

axios.defaults.headers.post.Accept = 'application/json';
axios.defaults.headers['Content-Type'] = 'application/json';
axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE';
axios.defaults.headers['Access-Control-Allow-Headers'] = 'Authorization';

const url = production
  ? "https://us-central1-universia-prod.cloudfunctions.net/"
  : "https://us-central1-universia-dev.cloudfunctions.net/";

export const setDocumenteElastic = async (data) => {
  try {
    return await axios.request({
      baseURL: url,
      url: "saveElasticAnyIndex",
      method: "POST",
      data
    });
  } catch (e) {
    console.log(e);
    return false;
  }
};

export default axios;